<template>
  <div class="tpp-page">
    <zhuomuniao-ops-nav active-path="/pages/tpp/zhuomuniao/accounts" :platform-id="platformId" />
    <section class="tpp-panel">
      <div class="tpp-panel__head">
        <div>
          <h2 class="tpp-panel__title">合作账号</h2>
          <p class="tpp-muted">配置 AppId、基址与签名密钥，供 createOrder / queryOrder / cancelOrder 调用。同环境只启用一套。</p>
        </div>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openEditor()">新增账号</el-button>
      </div>
      <el-alert title="测试基址仅 TEST 使用；生产必须是 https://api-cds.xiujiadian.com/v1/。密钥按当前后端明文签名，不要填写 env: 引用。" type="info" :closable="false" show-icon />
      <div class="tpp-filter" style="margin-top:12px">
        <el-select v-model="filters.env" placeholder="环境" clearable style="width:120px">
          <el-option label="测试" value="TEST" /><el-option label="生产" value="PROD" />
        </el-select>
        <el-input v-model.trim="filters.appId" placeholder="AppId" clearable style="width:180px" @keyup.enter.native="search" />
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      </div>
    </section>
    <section class="tpp-panel">
      <el-table v-loading="loading" :data="rows" border>
        <el-table-column label="环境" width="80" align="center">
          <template slot-scope="scope"><el-tag :type="scope.row.env === 'PROD' ? 'danger' : 'info'" size="small">{{ scope.row.env === 'PROD' ? '生产' : '测试' }}</el-tag></template>
        </el-table-column>
        <el-table-column prop="appId" label="AppId" min-width="140" />
        <el-table-column prop="baseUrl" label="基址 URL" min-width="220" show-overflow-tooltip />
        <el-table-column label="启用" width="80" align="center">
          <template slot-scope="scope"><el-tag :type="scope.row.enabled === 'Y' ? 'success' : 'info'" size="small">{{ scope.row.enabled === 'Y' ? '是' : '否' }}</el-tag></template>
        </el-table-column>
        <el-table-column label="加密 PII" width="90" align="center">
          <template slot-scope="scope">{{ scope.row.encryptPii === 'Y' ? '是' : '否' }}</template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip />
        <el-table-column label="操作" width="140" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="openEditor(scope.row)">编辑</el-button>
            <el-button type="text" class="tpp-danger" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="tpp-pagination" :current-page.sync="page.current" :page-size="page.size" :total="page.total"
        layout="total, prev, pager, next" @current-change="load" />
    </section>
    <el-dialog :title="form.accountId ? '编辑合作账号' : '新增合作账号'" :visible.sync="editorVisible" width="560px">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="环境" prop="env">
          <el-radio-group v-model="form.env"><el-radio label="TEST">测试</el-radio><el-radio label="PROD">生产</el-radio></el-radio-group>
        </el-form-item>
        <el-form-item label="AppId" prop="appId"><el-input v-model.trim="form.appId" maxlength="64" /></el-form-item>
        <el-form-item label="Secret" prop="secretRef">
          <el-input v-model="form.secretRef" type="password" show-password maxlength="128" :placeholder="form.accountId ? '留空则不修改' : '请输入 Secret'" />
        </el-form-item>
        <el-form-item label="基址 URL"><el-input v-model.trim="form.baseUrl" maxlength="255" placeholder="https://..." /></el-form-item>
        <el-form-item label="启用">
          <el-radio-group v-model="form.enabled"><el-radio label="Y">是</el-radio><el-radio label="N">否</el-radio></el-radio-group>
        </el-form-item>
        <el-form-item label="加密 PII">
          <el-radio-group v-model="form.encryptPii"><el-radio label="Y">是</el-radio><el-radio label="N">否</el-radio></el-radio-group>
        </el-form-item>
        <el-form-item label="备注"><el-input v-model.trim="form.remark" type="textarea" :rows="2" maxlength="256" /></el-form-item>
      </el-form>
      <span slot="footer"><el-button @click="editorVisible=false">取消</el-button><el-button type="primary" :loading="saving" @click="submit">保存</el-button></span>
    </el-dialog>
  </div>
</template>
<script>
import ZhuomuniaoOpsNav from './zhuomuniaoNav.vue'
import { zhuomuniaoOpsMixin } from './zhuomuniaoOpsMixin'
import { listAccounts, saveAccount, updateAccount, deleteAccount } from '@/api/life/homeServiceApi'
import { zmnTotal } from '@/api/tpp/zhuomuniaoOpsApi'
import '../tpp.scss'
function emptyForm() {
  return { accountId: '', env: 'TEST', appId: '', secretRef: '', baseUrl: '', enabled: 'N', encryptPii: 'N', remark: '' }
}
export default {
  name: 'ZhuomuniaoAccounts',
  components: { ZhuomuniaoOpsNav },
  mixins: [zhuomuniaoOpsMixin],
  data() {
    return {
      loading: false, saving: false, editorVisible: false, rows: [],
      filters: { env: '', appId: '' }, page: { current: 1, size: 10, total: 0 }, form: emptyForm(),
      rules: { env: [{ required: true, message: '请选择环境', trigger: 'change' }], appId: [{ required: true, message: '请输入 AppId', trigger: 'blur' }] }
    }
  },
  async created() { if (await this.ensureZhuomuniaoPlatform()) this.load() },
  methods: {
    search() { this.page.current = 1; this.load() },
    async load() {
      this.loading = true
      try {
        const res = await listAccounts({ ...this.filters, page: this.page.current, row: this.page.size })
        this.rows = res.data || []
        this.page.total = zmnTotal(res)
      } catch (e) { this.$message.error(e.message || '账号加载失败') }
      finally { this.loading = false }
    },
    openEditor(row) {
      this.form = row ? { ...row, secretRef: '' } : emptyForm()
      this.editorVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    submit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        if (!this.form.accountId && !this.form.secretRef) { this.$message.warning('新增账号时 Secret 不能为空'); return }
        this.saving = true
        try {
          const payload = { ...this.form }
          if (this.form.accountId && !payload.secretRef) delete payload.secretRef
          if (this.form.accountId) await updateAccount(payload)
          else await saveAccount(payload)
          this.$message.success('合作账号已保存')
          this.editorVisible = false
          this.load()
        } catch (e) { this.$message.error(e.message || '保存失败') }
        finally { this.saving = false }
      })
    },
    async remove(row) {
      try {
        await this.$confirm(`确认删除账号「${row.appId}」？`, '删除账号', { type: 'warning' })
        await deleteAccount({ accountId: row.accountId })
        this.$message.success('已删除'); this.load()
      } catch (e) { if (e !== 'cancel') this.$message.error(e.message || '删除失败') }
    }
  }
}
</script>
